import SEOHead from "@/components/feature/SEOHead";

const faqData = [
  {
    q: "樱花视频是否免费？",
    a: "是的，樱花视频平台上的所有视频内容均完全免费，用户无需支付任何费用即可畅享高清在线观看体验。我们致力于为用户提供优质的数字视频服务。",
  },
  {
    q: "需要注册账号才能观看吗？",
    a: "不需要。樱花视频无需注册即可直接观看所有视频内容，真正做到即点即看，方便快捷。",
  },
  {
    q: "支持哪些设备观看？",
    a: "樱花视频支持PC电脑、笔记本电脑、平板电脑、智能手机等多种设备。只要您有浏览器和网络连接，就可以随时随地观看91视频、97视频等高清内容。",
  },
  {
    q: "视频播放卡顿怎么办？",
    a: "樱花视频采用全球CDN加速技术，确保播放流畅。如遇卡顿，建议检查网络连接或尝试切换视频清晰度。我们的技术团队会持续优化播放体验。",
  },
  {
    q: "内容多久更新一次？",
    a: "樱花视频的内容团队每日更新视频资源，涵盖电影、电视剧、综艺、动漫、纪录片等多元品类，确保您总能发现新鲜有趣的视频内容。",
  },
];

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqData.map((item) => ({
    "@type": "Question",
    name: item.q,
    acceptedAnswer: {
      "@type": "Answer",
      text: item.a,
    },
  })),
};

const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "樱花视频",
  url: "https://www.sakuramovie.com",
  description:
    "樱花视频是一家领先的数字视频平台，提供91视频、97视频、51视频等高清在线观看服务。",
  address: {
    "@type": "PostalAddress",
    addressLocality: "北京",
    addressRegion: "朝阳区",
    streetAddress: "樱花路88号",
    addressCountry: "中国",
  },
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "400-888-9999",
    contactType: "customer service",
  },
};

const aboutSchema = {
  "@context": "https://schema.org",
  "@type": "AboutPage",
  name: "关于樱花视频 - 品牌介绍与联系方式",
  description:
    "了解樱花视频的品牌故事、核心优势与联系方式。樱花视频是领先的数字视频平台，提供91视频、97视频高清在线观看。",
  url: "https://www.sakuramovie.com/about",
};

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "首页",
      item: "https://www.sakuramovie.com",
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "关于我们",
      item: "https://www.sakuramovie.com/about",
    },
  ],
};

export default function About() {
  return (
    <>
      <SEOHead
        title="关于我们 - 樱花视频 | 品牌介绍与联系方式"
        description="了解樱花视频的品牌故事、核心优势与联系方式。樱花视频是领先的数字视频平台，提供91视频、97视频、51视频等高清在线观看服务，致力打造极致的观影体验。"
        keywords="樱花视频,关于我们,品牌介绍,联系方式,数字视频平台"
        canonicalUrl="/about"
        ogType="website"
        schemaData={{ ...orgSchema, ...aboutSchema, ...faqSchema, ...breadcrumbSchema }}
      />

      <section className="w-full px-4 md:px-6 py-8 md:py-12 max-w-screen-2xl mx-auto">
        <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-8 text-center" style={{ fontFamily: "var(--font-heading)" }}>
          关于樱花视频
        </h1>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 mb-14 max-w-5xl mx-auto">
          <div>
            <h2 className="text-lg md:text-xl font-semibold text-foreground-950 mb-4">
              品牌介绍
            </h2>
            <div className="space-y-3 text-sm text-foreground-700 leading-relaxed">
              <p>
                樱花视频成立于2020年，是一家专注于数字视频在线观看服务的创新型平台。我们汇聚了<strong>91视频</strong>、<strong>97视频</strong>、<strong>51视频</strong>等优质内容品牌，致力于为广大用户提供高清、流畅、免费的视频观看体验。
              </p>
              <p>
                平台上线以来，樱花视频始终坚持"内容为王、用户至上"的理念，不断丰富视频资源库，目前已经积累了超过10万部影视作品，涵盖电影、电视剧、综艺、动漫、纪录片、短视频等多元内容品类。
              </p>
              <p>
                我们的技术团队持续优化播放体验，采用先进的视频编码技术和全球CDN加速网络，确保用户无论身处何地，都能享受到不缓冲、不卡顿的极致观影体验。樱花视频，让数字视频触手可及。
              </p>
            </div>
          </div>

          <div>
            <h2 className="text-lg md:text-xl font-semibold text-foreground-950 mb-4">
              核心优势
            </h2>
            <ul className="space-y-3">
              {[
                { title: "完全免费", desc: "所有视频内容永久免费，无需会员，无需付费" },
                { title: "高清画质", desc: "支持1080P/4K超高清播放，画质清晰细腻" },
                { title: "海量资源", desc: "超过10万部影视作品，涵盖全品类内容" },
                { title: "更新迅速", desc: "每日持续更新，第一时间呈现最新资源" },
                { title: "多端支持", desc: "PC、手机、平板全终端覆盖，随时随地观看" },
              ].map((item) => (
                <li key={item.title} className="flex gap-3 p-3 bg-background-50 rounded-lg border border-background-200/70">
                  <div className="w-6 h-6 flex items-center justify-center shrink-0 mt-0.5">
                    <i className="ri-checkbox-circle-fill text-accent-500"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-950">{item.title}</h3>
                    <p className="text-xs text-foreground-600">{item.desc}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mb-14 max-w-5xl mx-auto">
          <h2 className="text-lg md:text-xl font-semibold text-foreground-950 mb-6 text-center">
            用户口碑
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {[
              { name: "王先生", text: "樱花视频真的太方便了，不用注册就能看，画质也很清晰，已经推荐给很多朋友了！", rating: 5 },
              { name: "李女士", text: "91视频和97视频的内容非常丰富，每天下班回家都会打开樱花视频看一会儿，放松心情。", rating: 5 },
              { name: "张同学", text: "作为一个电影爱好者，樱花视频满足了我所有的观影需求，资源全、更新快，五星好评！", rating: 5 },
            ].map((review) => (
              <div key={review.name} className="p-5 bg-background-50 rounded-lg border border-background-200/70">
                <div className="flex items-center gap-1 mb-3">
                  {Array.from({ length: review.rating }).map((_, i) => (
                    <div key={i} className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-star-fill text-accent-500 text-sm"></i>
                    </div>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                  &ldquo;{review.text}&rdquo;
                </p>
                <p className="text-xs text-foreground-500 font-medium">{review.name}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="max-w-5xl mx-auto mb-14">
          <h2 className="text-lg md:text-xl font-semibold text-foreground-950 mb-6 text-center">
            联系方式
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="p-5 bg-background-50 rounded-lg border border-background-200/70 text-center">
              <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100">
                <i className="ri-mail-line text-lg text-primary-500"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-950 mb-1">电子邮箱</h3>
              <p className="text-xs text-foreground-600">contact@sakuramovie.com</p>
            </div>
            <div className="p-5 bg-background-50 rounded-lg border border-background-200/70 text-center">
              <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100">
                <i className="ri-phone-line text-lg text-primary-500"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-950 mb-1">客服电话</h3>
              <p className="text-xs text-foreground-600">400-888-9999</p>
            </div>
            <div className="p-5 bg-background-50 rounded-lg border border-background-200/70 text-center">
              <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100">
                <i className="ri-map-pin-line text-lg text-primary-500"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-950 mb-1">公司地址</h3>
              <p className="text-xs text-foreground-600">北京市朝阳区樱花路88号</p>
            </div>
          </div>
        </div>

        <div className="max-w-3xl mx-auto">
          <h2 className="text-lg md:text-xl font-semibold text-foreground-950 mb-6 text-center">
            常见问题
          </h2>
          <div className="space-y-3">
            {faqData.map((faq, i) => (
              <details key={i} className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden cursor-pointer">
                <summary className="flex items-center justify-between p-4 text-sm font-medium text-foreground-950 select-none">
                  {faq.q}
                  <div className="w-5 h-5 flex items-center justify-center shrink-0 ml-2 group-open:rotate-180 transition-transform">
                    <i className="ri-arrow-down-s-line"></i>
                  </div>
                </summary>
                <div className="px-4 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}